import axios from "axios";

export function configureRequestInterceptor(authToken) {
    axios.interceptors.request.use(request => {
        request.headers.Authorization = 'Bearer ' + authToken;
        return request;
    });
}